import PropTypes from 'prop-types';
import { useContext } from 'react';

// Simple hook to manually invoke the prop-types engine against your contextType defs
export const useContextTypes = (displayName, ctx, contextTypes) => {
  PropTypes.checkPropTypes(contextTypes, useContext(ctx), 'context', displayName);
};
